import { z } from 'zod';
import { HateoasTargetSchema } from './actions';

const HateoasTemplatePropertySchema = z.object({
    name: z.string(),
    type: z.string().optional(),
    prompt: z.string().optional(),
    required: z.boolean().optional(),
    readOnly: z.boolean().optional(),
    hidden: z.boolean().optional(),
    value: z.unknown().optional(),
    options: z.array(z.unknown()).optional(),
});

const HateoasTemplateSchema = z.object({
    title: z.string(),
    method: z.enum(['GET', 'POST', 'PUT', 'DELETE', 'PATCH', 'ALL', 'OPTIONS', 'HEAD']),
    target: z.string(),
    contentType: z.literal('application/json').optional(),
    properties: z.array(HateoasTemplatePropertySchema),
});

/**
 * HATEOAS Générique
 */
export const HateoasEffectSchema = z.enum([
    'redirect',
    'notify',
    'open_modal',
    'refresh',
    'clear_session',
    'refresh_session',
    'session'
]);
export type HateoasEffect = z.infer<typeof HateoasEffectSchema>;

const SessionValueSchema = z.union([
    z.string(),
    z.object({ path: z.string() }),
]);

const UiEffectSchema = z.object({
    effects: z.array(HateoasEffectSchema),
    target: z.string().optional(),
    message: z.string().optional(),
    session: z.object({
        set: z.record(z.string(), SessionValueSchema).optional(),
        clear: z.array(z.string()).optional(),
    }).optional(),
});
export type UiEffect = z.infer<typeof UiEffectSchema>;

export const HateoasResponseSchema = z.object({
    resources: z.unknown().optional(),
    _links: z.record(z.string(), HateoasTargetSchema).optional(),
    _actions: z.record(z.string(), HateoasTargetSchema).optional(),
    templates: z.record(z.string(), HateoasTemplateSchema).optional(),
    ui: UiEffectSchema.optional(),
});
export type HateoasResponse = z.infer<typeof HateoasResponseSchema>;